var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"wrap"},[_c('p',{staticClass:"footer__text"},[_vm._v("@copyright by scientific center")]),_c('a',{staticClass:"creator",attrs:{"href":"http://alexey-chernov.ru/","target":"_blank"}},[_c('p',[_vm._v("This site created by")]),_c('img',{attrs:{"src":require("@/assets/images/creator.svg")}})])])])
}]

export { render, staticRenderFns }